/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SubmitAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function SubmitAction({
  children,
  viewPath = "/App/Widget/Content/Questions/Review/Progress/Action/SubmitAction",
  onSubmit,
  isSubmitting
  
}) {
let selectedSubmitData = fromData.useDataSubmit({ viewPath,
context: 'selected',
})
let selectedIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'selected',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 size="small"
 alignSelf="flex-end"
 paddingBottom={dtSpaceXs}
 paddingTop={dtSpaceXs}
 paddingLeft={dtSpaceXs}
 paddingRight={dtSpaceXs}
 data="selected"
 onClick={selectedSubmitData}
 disabled={selectedIsSubmittingData}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Confirm"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}